import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from 'react-router-dom';

const CardContacto =
  ({
    contact,
    setSelectContact,
    user,
    handlerOpenModalObservaciones,
    handlerOpenModal,
    formData,
    setFormData,
    selectedContact,
    click,
    setClick
  }) => {
    const navigate = useNavigate();
    const [editorContacto, setContacto] = useState(false);

    function convertirFecha(fechaString) {
      const fecha = new Date(fechaString);
      const dia = fecha.getDate();
      const mes = fecha.getMonth() + 1; // Los meses comienzan desde 0, por lo que se suma 1
      const año = fecha.getFullYear();
      const hora = fecha.getHours();
      const minutos = fecha.getMinutes();

      // Formatear los componentes de la fecha/hora para que tengan dos dígitos
      const diaFormateado = dia < 10 ? '0' + dia : dia;
      const mesFormateado = mes < 10 ? '0' + mes : mes;
      const horaFormateada = hora < 10 ? '0' + hora : hora;
      const minutosFormateados = minutos < 10 ? '0' + minutos : minutos;

      // Construir la cadena de fecha en el formato deseado
      const fechaFormateada =
        `${horaFormateada}:${minutosFormateados}hs - ${diaFormateado}/${mesFormateado}/${año}`;

      return fechaFormateada;
    }

    const link = contact?.status === "Cliente" ? '/clientes/' + `${contact.id}` : '/contacts/' + `${contact.id}`
    return (

      <StyledLink to={link} target="_blank" style={{
        backgroundColor: click === contact.id ? '#dddddd' : '#FFFFFF'
      }}
        onClick={() => setClick(contact.id)}
        key={contact.id}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          width: "50%"
        }}>
          <Text
            selectedContact={selectedContact}
            contact={contact}>

            {contact.name} {contact.lastname}

          </Text>
          <Text
            style={{
              fontSize: '10px',
            }}
            selectedContact={selectedContact}
            contact={contact}>
            {
              contact.Observaciones && contact.Observaciones?.length > 0 ?
                <>
                  {'Último contacto ' + convertirFecha(contact.Observaciones[contact.Observaciones.length - 1].updatedAt)} </> :

                <>
                  {
                    contact.status === "Cliente" ?
                      <p style={{ color: "#58d23e", margin: "0px", fontSize: "14px" }}>Cliente</p> : "Sin Contactar"
                  }
                </>
            }
          </Text>
        </div>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          width: "50%"

        }} >
          <Text1>

            <b>Última observación.</b>

          </Text1>

          <Text1>

            {
              contact.Observaciones && contact.Observaciones?.length > 0 ?
                <>

                  {contact.Observaciones[contact.Observaciones.length - 1].observacion}
                </> : 'Sin contactar'
            }

          </Text1>
        </div>
      </StyledLink>
    );
  };

export default CardContacto;

const StyledLink = styled(Link)`
  width: -webkit-fill-available;
  padding: 8px;
  display: flex;
  flex-direction: row;
  gap: 5px;
  height: auto;
  align-content: flex-start;
  justify-content: start;
  align-items: center;
  border-top: 1.5px solid #e1e3ea;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
  cursor: pointer;
  background-color: 'transparent' ;
  transition: all 0.3s ease-in-out;
  outline: none;
  text-decoration: none;
  &:hover{
      box-shadow: rgba(60, 64, 67, 0.9) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
      opacity: 0.5;
      will-change: transform;
  }
`;

const Text = styled.span`
  width: -webkit-fill-available;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: ${(prop) => prop.selectedContact?.id === prop.contact.id ? '#07082c' : '#07082c'}  ;
`;

const Text1 = styled.span`
  width: -webkit-fill-available;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #07082c;
`;